<script lang="ts">
	import { StatusIndicator } from '@Shelly/shelly-design-system';
	import { getEvWorkingState } from 'src/helpers/xt1_helpers/ev_charger/ev_charger_helpers';
	//Components
	import EvChargerSessions from './EvChargerSessions.svelte';
	import EvChargerCharging from './EvChargerCharging.svelte';
	import EvChargerStatuses from './EvChargerStatuses.svelte';
	import EvChargerControl from './EvChargerControl.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let device: Device, statuses: VCInterfaceStatus[];

	let lastWorkState = null;

	$: workState = getEvWorkingState(statuses.find((i) => i?.role === 'work_state')?.event);
	$: if (lastWorkState !== workState?.state) {
		lastWorkState = workState?.state;
	}
</script>

<div class="flex-full-height justify-content-end">
	{#if workState}
		<div class="d-flex justify-content-center mb-m mt-s">
			<StatusIndicator
				state={workState.state}
				title={workState.state === 'charging'
					? statuses.find((i) => /^(total_power)$/.test(i?.role))?.value
					: workState.title}
				subtitle={workState.subtitle}
			/>
		</div>
	{/if}
	{#key lastWorkState}
		{#if /^(charging|paused)$/.test(lastWorkState)}
			<EvChargerCharging {device} {statuses} />
		{:else if /^(idle|completed)$/.test(lastWorkState)}
			<EvChargerSessions {device} {workState} />
		{:else}
			<EvChargerStatuses {statuses} />
		{/if}
	{/key}
	<EvChargerControl {device} {statuses} isWide />
</div>
